// extracted by mini-css-extract-plugin
export const inlineList = "ItemList-module--inline-list--2iT7j";
export const item = "ItemList-module--item--3n1J_";